import { render, staticRenderFns } from "./DesignProjects.vue?vue&type=template&id=e08e40b6&scoped=true&"
import script from "./DesignProjects.vue?vue&type=script&lang=js&"
export * from "./DesignProjects.vue?vue&type=script&lang=js&"
import style0 from "./DesignProjects.vue?vue&type=style&index=0&id=e08e40b6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e08e40b6",
  null
  
)

export default component.exports